// extracted by mini-css-extract-plugin
export default {"root":"scroll_root__JqfDG"};